export const testTypes = {
  MULTIPLE_TYPE: 1,
  PUZZLE_TYPE: 2,
};
